import React from 'react';
import { NoticeStyles } from './NoticeStyles';

const Notice = ({ type, message }) => {
  const theme = {
    background: '#dcedf6',
    border: '#c1def0',
    color: '#3d708d',
  };
  if (type === 'warning') {
    theme.background = 'white';
    theme.border = '#ee9800';
    theme.color = '#ee9800';
  }
  if (type === 'error') {
    theme.background = '#f8d7da';
    theme.border = '#f5c6cb';
    theme.color = '#721c24';
  }

  return (
    <NoticeStyles theme={theme}>
      <>
        { (typeof message == 'string') && (<p className="message">{message}</p>)}
      </>
    </NoticeStyles>
  );
};

export default Notice;
